import {
  INVENTORY,
  KEY_TILES_MAP,
  LOCK_AND_KEY_COLORS,
  PLACEMENT_TYPE_HERO,
} from "../helpers/consts";
import ElevatedTile from "../components/object-graphics/TileElevated";
import { PickupPlacement } from "./PickupPlacement";

export class KeyPickupPlacement extends PickupPlacement {
  constructor(properties, level) {
    super(properties, level);
    this.color = properties.color ?? LOCK_AND_KEY_COLORS.BLUE;
  }

  addsItemToInventoryOnCollide(body) {
    if (body.type !== PLACEMENT_TYPE_HERO) {
      return null;
    }

    if (this.color === LOCK_AND_KEY_COLORS.GREEN) {
      return INVENTORY.GREEN_KEY_PICKUP;
    }
    if (this.color === LOCK_AND_KEY_COLORS.BLUE) {
      return INVENTORY.BLUE_KEY_PICKUP;
    }
    return null;
  }

  canBeStolen() {
    return true;
  }

  renderComponent() {
    const frameCoord = KEY_TILES_MAP[this.color].KEY;
    return (
      <ElevatedTile frameCoord={frameCoord} pxAboveGround={6} hover={true} />
    );
  }
}
